import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Context from './Context'
import { decodeJWT, setToken, getToken } from "../utils/auth";

const Provider = ({ children }) => {

    const navigate = useNavigate();

    const [snackbarSignal, setSnackbarSignal] = useState({
        message: '',
        show: false,
        status: 'success',
    });

    const [isLoading, setIsLoading] = useState(true)
    const [prevLoc, setPrevLoc] = useState("")
    const showSnackbar = (message, status) => {
        setSnackbarSignal({
            message,
            show: true,
            status,
        })
    };

    const hideSnackbar = () => {
        setSnackbarSignal({
            ...snackbarSignal,
            show: false,
        })
    };

    const initialToken = getToken();
    const [authToken, setAuthToken] = useState(initialToken);
    const [user, setUser] = useState(decodeJWT(initialToken));

    const handleLogin = (jwt) => {
        setToken(jwt)
        setAuthToken(jwt);
        setUser(decodeJWT(jwt));
        navigate("/");
    };

    const handleLogout = () => {
        setAuthToken(null);
        setUser(null);
        navigate("/invite");
    };

    useEffect(() => {
        const handler = () => handleLogout();
        window.addEventListener("app:logout", handler);
        return () => window.removeEventListener("app:logout", handler);
    }, []);

    return (
        <Context.Provider
            value={{
                snackbarSignal,
                showSnackbar,
                hideSnackbar,
                isLoading,
                setIsLoading,
                prevLoc,
                setPrevLoc,
                authToken,
                user,
                handleLogin,
                handleLogout,
            }}
        >
            {children}
        </Context.Provider>
    );

}

export default Provider;